export default "__VITE_ASSET__9354ff92__"